@if (showStickers) {
  <div class="sticker-group" [ngClass]="size ? 'sticker-group--' + size : null">
    @if (showDonate) {
      <ng-container *ngTemplateOutlet="donateSticker"></ng-container>
    }
    @if (unavailable || (product && !isAvailable)) {
      <ng-container *ngTemplateOutlet="notAvailable"></ng-container>
    }
    @if (!showDonate && !unavailable && (points !== undefined || (product && isAvailable))) {
      @if (!discountOnly && pointsString) {
        <div class="sticker sticker--miles" [ngClass]="size ? 'sticker--' + size : null">
          @if (showTopLabel) {
            <span class="sticker__top-label">{{ 'general.label.from' | translate }}</span>
          }
          <span class="sticker__counter">{{ pointsString }}</span>
          <span class="sticker__label">{{ 'general.label.air_miles' | translate }}</span>
        </div>
      }
      @if (discountOnly && discount) {
        <div class="sticker sticker--discount-only">
          <span class="sticker__counter">{{ discount | currency }}</span>
          <span class="sticker__label">{{ 'general.label.discount' | translate }}</span>
        </div>
      }
      @if (productCost; as cost) {
        @if (cost.price) {
          <div class="sticker sticker--euro" [ngClass]="size ? 'sticker--euro--' + size : null">
            <span class="sticker__counter">+{{ cost.price | currency }}</span>
          </div>
        }
        @if (discount && !cost.price && !discountOnly) {
          <div class="sticker sticker--discount" [ngClass]="size ? 'sticker--discount--' + size : null">
            <span class="sticker__counter">{{ discount | currency }}</span>
            <span class="sticker__label">{{ 'general.label.discount' | translate }}</span>
          </div>
        }
        @if (!cost.price && !discount) {
          <div class="sticker sticker--miles-only" [ngClass]="size ? 'sticker--miles-only--' + size : null">
            <span class="sticker__label">{{ 'general.label.miles_only' | translate }}</span>
          </div>
        }
      }
    }
  </div>
}

<ng-template #donateSticker>
  <div class="sticker sticker--donate" [ngClass]="size ? 'sticker--donate--' + size : null">
    <span class="sticker__label">{{ 'general.label.donate' | translate }}</span>
  </div>
</ng-template>

<ng-template #notAvailable>
  <div class="sticker sticker--not-available" [ngClass]="size ? 'sticker--not-available--' + size : null">
    <span class="sticker__label">{{ 'general.label.temporarily_unavailable' | translate }}</span>
  </div>
</ng-template>
